module.exports = __webpack_public_path__ + "static/media/close-outline.0b45a697.svg";